import React from 'react';
import { Certification } from '@axiom/const';
import type { BioRenderableCandidate } from '@axiom/validation';

import { Layout } from '../../layout/Layout/Layout';
import { Gutter } from '../../layout/Gutter/Gutter';
import { SectionHeader } from '../../content/SectionHeader/SectionHeader';
import { Paragraph } from '../../content/Paragraph/Paragraph';
import { ParagraphHeader } from '../../content/ParagraphHeader/ParagraphHeader';
import { QualificationsCertificationsAccomplishmentsUtil } from '../../../utils/qualifications-certifications-accomplishments-util';

const { QUALIFICATION_AWARDS } = Certification;

export const TalentQualifications = ({
  candidate,
}: {
  candidate: BioRenderableCandidate;
}) => {
  const awardTypes = Object.values(QUALIFICATION_AWARDS);
  const qualifications = (candidate.certifications || []).filter(cert =>
    awardTypes.includes(cert.award)
  );

  return qualifications.length > 0 ? (
    <>
      <SectionHeader name="Qualifications">Qualifications</SectionHeader>
      <Gutter bottom="12px" />
      <Layout direction="vertical" verticalGutter="12px">
        {qualifications.map(cert => {
          const { award, institution, year } = cert;
          const institutionYearText =
            QualificationsCertificationsAccomplishmentsUtil.getInstitutionYearText(
              cert
            );

          return (
            <div
              data-test="QUALIFICATION_AWARD"
              key={`${award}_${institution}_${year}`}
            >
              <ParagraphHeader name="AWARD_NAME">{award}</ParagraphHeader>

              {institutionYearText ? (
                <Paragraph name="INSTITUTION_YEAR" as="span">
                  {institutionYearText}
                </Paragraph>
              ) : null}
            </div>
          );
        })}
      </Layout>
    </>
  ) : null;
};
